import React, { useEffect, useState } from "react";

import Sheet from "components/sheet/Sheet";
import Input from "components/form/input/Input";
import DataTable from "components/dataTable/DataTable";
import Checkbox from "components/form/checkbox/Checkbox";
import { PostWelcomeEmail } from "api/rpc/2024-04/facilityAdmin/customer/type";
import { StatusCode } from "api/protocols";
import { useAppDispatch } from "hooks/redux";
import { showError, showSuccess } from "redux/actions/ui";
import { useTranslation } from "react-i18next";

interface IWelcomeEmailModal {
  isOpen: boolean;
  customerTypes: any;
  onClose: () => void;
}
export default function WelcomeEmailModal(props: IWelcomeEmailModal) {
  const { customerTypes } = props;
  const dispatch = useAppDispatch();
  const { t } = useTranslation();

  const [filterState, setFilterState] = useState({
    search: undefined,
  });

  const [selectedTypesState, setSelectedTypesState] = useState<number[]>([]);
  const [bufferTypeState, setBufferTypeState] = useState(customerTypes);

  useEffect(() => {
    if (filterState?.search === "") {
      setBufferTypeState(customerTypes);
    } else {
      if (filterState?.search === undefined) {
        return;
      }
      console.log("triggered filter");
      const filteredTypes = customerTypes?.filter((type: { title: string }) =>
        type?.title?.toLowerCase().includes(filterState.search?.toLowerCase()),
      );
      setBufferTypeState(filteredTypes);
    }
  }, [filterState?.search]);

  function handleSelectAllCheckbox(e: React.ChangeEvent<HTMLInputElement>) {
    const { checked } = e.target;

    if (!checked) {
      setSelectedTypesState([]);
    } else {
      void handleSetAllClick();
    }
  }

  const handleSetAllClick = () => {
    const allCustomerTypeIDs = customerTypes.map((type: { id: number }) => {
      return type?.id;
    });

    setSelectedTypesState(allCustomerTypeIDs);
  };

  function clearState() {
    setFilterState({ search: "" });
    setSelectedTypesState([]);
  }

  function handleCheckboxToggle(type_id: number) {
    const foundIndex = selectedTypesState.indexOf(type_id);

    if (foundIndex === -1) {
      setSelectedTypesState(prev => [...prev, type_id]);
    } else {
      setSelectedTypesState(prev => prev.filter(val => val !== type_id));
    }
  }

  async function handleOk() {
    const welcomeEmailRes = await PostWelcomeEmail({ customer_type_ids: selectedTypesState }, true);

    if (welcomeEmailRes.status !== StatusCode.OK) {
      dispatch(showError(t("secure.facility.settings.customer_type.components.welcome_email_modal.001")));
      return;
    }

    dispatch(showSuccess(t("secure.facility.settings.customer_type.components.welcome_email_modal.002")));
    void clearState();
    props.onClose();
  }

  function handleClose() {
    void clearState();
    props.onClose();
  }

  return (
    <Sheet
      open={props.isOpen}
      size="small"
      height="flexible"
      closable
      title={t("secure.facility.settings.customer_type.components.welcome_email_modal.003")}
      supportText={t("secure.facility.settings.customer_type.components.welcome_email_modal.004")}
      onOk={() => handleOk()}
      okDisabled={selectedTypesState.length === 0 ? true : false}
      cancelText={t("secure.facility.settings.customer_type.components.welcome_email_modal.005")}
      okText={t("secure.facility.settings.customer_type.components.welcome_email_modal.006")}
      onCancel={() => handleClose()}
    >
      <div className="flex flex-col">
        <Input
          value={filterState.search}
          onChange={(value: any) => setFilterState({ search: value.target.value })}
          type="search"
          placeholder={t("secure.facility.settings.customer_type.components.welcome_email_modal.007")}
          autoFocus
          labelHidden
          className="mb-4"
        />

        <DataTable
          columns={[
            {
              content: (
                <Checkbox
                  size="small"
                  checked={selectedTypesState?.length === customerTypes?.length}
                  onChange={e => handleSelectAllCheckbox(e)}
                />
              ),
              label: "",
              width: "5%",
            },
            {
              label: t("secure.facility.settings.customer_type.components.welcome_email_modal.008"),
            },
          ]}
        >
          {bufferTypeState?.map((customerType: { id: number; title: string }, index: React.Key) => {
            return (
              <tr key={index}>
                <td>
                  <Checkbox
                    size="small"
                    value={customerType.id}
                    checked={selectedTypesState?.includes(customerType.id)}
                    onChange={() => handleCheckboxToggle(customerType.id)}
                  />
                </td>
                <td>{customerType.title}</td>
              </tr>
            );
          })}
        </DataTable>
      </div>
    </Sheet>
  );
}
